import { render } from "./UserReferenceList.vue?vue&type=template&id=d78beea2&scoped=true&ts=true"
import script from "./UserReferenceList.vue?vue&type=script&lang=ts"
export * from "./UserReferenceList.vue?vue&type=script&lang=ts"

import "./UserReferenceList.vue?vue&type=style&index=0&id=d78beea2&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d78beea2"]])

export default __exports__